module.exports = __webpack_public_path__ + "static/media/monitor.938e26a4.png";